import { render } from "./combination.vue?vue&type=template&id=ceb211f2&scoped=true"
import script from "./combination.vue?vue&type=script&lang=js"
export * from "./combination.vue?vue&type=script&lang=js"

import "./combination.vue?vue&type=style&index=0&id=ceb211f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ceb211f2"]])

export default __exports__